let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8gytj")).then(() => parcelRequire('3UlV5'));